import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/notifications/mark-as-read/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const markAsRead = {
  post: apiPathFunc(pathBase),
} as const;
